import React from 'react';
import Reflux from 'reflux';
import AppStore from '../AppStore';
import AppActions from '../AppActions';
import RcIf from 'rc-if';
import {Link} from 'react-router-dom';

export default class UserListItem extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            followed: false,
            itsYou: false
        };
        this.store = AppStore;
    }
    componentDidMount () {
        this.checkIfFollowed();
    }
    checkIfFollowed = () => {
        if (this.state.userData && this.state.userData.following) {
            let index = this.state.userData.following.indexOf(this.props.user._id);
            this.setState({followed: (index >= 0)});
            if (this.state.userData.username === this.props.user.username) {
                this.setState({itsYou: true});
            }
        }
    }
    componentWillReceiveProps () {
        this.checkIfFollowed();
    }
    followUser = () => {
        AppActions.followUser(this.props.user._id);
    }
    unfollowUser = () => {
        AppActions.unfollowUser(this.props.user._id);
    }

    render () {
        return (
          <div className='col m6 s12'>
            <div className='box-follow'>
              <div className='UserTop'>
                <div className='user-box-txt'>
                  <Link to={'/p/' + this.props.user.username} className='profileThumb'>
                    <object type='image/jpg' data={this.props.user.profile_image.sizeSmall ? this.props.user.profile_image.sizeSmall : '/images/icons/default.jpg'}>
                      <img
                        src='/images/icons/default.jpg'
                        className='responsive-img' />
                    </object>
                  </Link>
                  <Link to={'/p/' + this.props.user.username} className='profileTxt'>
                    <a href=''>
                      {this.props.user.name}
                      <span><i className='fa fa-map-marker' aria-hidden='true' />Argentina</span>
                    </a>
                  </Link>
                </div>
              </div>
              <RcIf if={this.state.followed && (!this.state.itsYou)}>
                <a className='btn followed' onClick={this.unfollowUser}>Seguido</a>
              </RcIf>
              <RcIf if={(!this.state.followed) && (!this.state.itsYou)}>
                <a className='btn' onClick={this.followUser}>Seguir</a>
              </RcIf>
            </div>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sections/UserListItem.js